module.exports = __webpack_public_path__ + "fonts/CrimsonText-BoldItalic.baa72214.ttf";